<template>
  <div :class="containerClass">
    <video
      v-show="!loading"
      ref="videoRef"
      disablepictureinpicture
      webkit-playsinline
      playsinline
      :src="src"
      :class="videoClass"
      :poster="poster"
      :controls="controls"
      :autoplay="isAutoplay"
      :loop="loop"
      :muted="muted"
      @loadstart="loading = true"
      @loadeddata="loading = false"
      @error="loading = true"
      @mouseenter="!autoplay ? handleMouseEnter() : null"
      @mouseleave="!autoplay ? handleMouseLeave() : null"
    ></video>

    <div
      v-show="loading"
      :class="videoClass"
      class="w-full h-full animated-shimmer pointer-events-none"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        :viewBox="`0 0 ${config.video ? config?.video?.size?.width / 4 : 500} ${
          config.video ? config?.video?.size?.height / 4 : 500 / aspectRatio
        }`"
      ></svg>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

const props = defineProps({
  aspectRatio: { type: Number, default: 0.8 },
  src: String,
  videoClass: String,
  containerClass: String,
  poster: String,
  controls: { type: Boolean, default: false },
  autoplay: { type: Boolean, default: false },
  loop: { type: Boolean, default: false },
  muted: { type: Boolean, default: false },
  resetOnPause: { type: Boolean, default: true },
  config: { type: Object, default: () => ({}) },
});

const loading = ref(true);
const isAutoplay = ref(props.autoplay);

const videoRef = ref<HTMLVideoElement | null>(null);

const handleMouseEnter = () => {
  videoRef.value?.play();
};

const handleMouseLeave = () => {
  videoRef.value?.pause();
  if (props.resetOnPause && videoRef.value) {
    videoRef.value.currentTime = 0;
  }
};

// Reset skeleton when src changes
watch(
  () => props.src,
  () => {
    loading.value = true;
  },
);
</script>
